import { render } from "./viewTask.html?vue&type=template&id=68582637&scoped=true&ts=true&external"
import script from "./ViewTask.vue?vue&type=script&lang=ts"
export * from "./ViewTask.vue?vue&type=script&lang=ts"

import "./ViewTask.vue?vue&type=style&index=0&id=68582637&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68582637"]])

export default __exports__